var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoad)?_c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$t('page.register')),expression:"$t('page.register')"}],staticClass:"m-register"},[_c('Header',{attrs:{"extras":_vm.extras}}),_c('Banner',{attrs:{"extras":_vm.extras}}),_c('div',{staticClass:"m-reg-main"},[_c('div',{staticClass:"m-reg-form"},[_c('div',{staticClass:"m-reg-title",style:({
          color: _vm.extraItem.extras('titlefont.color'),
          fontSize: _vm.pxOrVw(_vm.extraItem.extras('titlefont.size')),
          fontWeight:
            _vm.extraItem.extras('titlefont.weight') == 'default'
              ? '500'
              : _vm.extraItem.extras('titlefont.weight'),
        })},[_vm._v(" "+_vm._s(_vm.extraItem.extras("titleText.model"))+" ")]),(!_vm.isTrackClosed)?_c('BaseComponent',{attrs:{"platform":'pc',"form-list":_vm.formList,"extras":_vm.extras}}):_c('FormStatus')],1),_c('div',{staticClass:"m-reg-footer-btns"},[(!_vm.isTrackClosed)?_c('button',{staticClass:"u-input-btn",style:({ color: _vm.extraItem.extras('ButtonText.fontColor') }),attrs:{"disabled":_vm.isSubmitting},on:{"click":_vm.beforeRegisterHandler}},[_vm._v(" "+_vm._s(_vm.$t("common.register"))+" ")]):_vm._e(),_c('button',{staticClass:"u-input-btn active",on:{"click":_vm.routerLogin}},[_vm._v(" "+_vm._s(_vm.$t("common.hasAccount"))+" ")])])]),(_vm.extraItem.extras('copyright.display'))?_c('div',{staticClass:"m-copyright",style:({
      textAlign: _vm.extraItem.extras('copyright.position'),
      color: _vm.extraItem.extras('copyright.color'),
      fontSize:
        _vm.extraItem.extras('copyright.fontSize') === 'big'
          ? '16px'
          : _vm.extraItem.extras('copyright.fontSize') === 'small'
          ? '12px'
          : '14px',
      fontWeight:
        _vm.extraItem.extras('copyright.bold') === 'bold' ? 'bold' : 'normal',
      fontStyle:
        _vm.extraItem.extras('copyright.italic') === 'italic'
          ? 'italic'
          : 'normal',
      whiteSpace: 'pre-line',
    })},[_vm._v(" "+_vm._s(_vm.extraItem.extras("copyright.model"))+" ")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }